import $ from "jquery";

import "ol/ol.css";
import Overlay from "ol/Overlay";
import { getArea, getLength } from "ol/sphere";
import { LineString, Polygon } from "ol/geom";
import Draw from "ol/interaction/Draw";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { WKT } from "ol/format";
import { Feature } from "ol";
import { getCenter } from "ol/extent";
import { MultiPolygon } from "ol/geom";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { transform } from "ol/proj";
//import { toStringHDMS } from "ol/coordinate";

export default class SisMeasure {
	constructor(map) {
		if (!map) {
			alert("map을 지정하여 주세요");
			return false;
		}

		this.map = map;
		this.type = "LineString";

		this.continueMsg = "계속 그리시려면 화면을 클릭하세요.<br>측정완료시 더블클릭하세요";
		this.overlayClassName = "ol-tooltip ol-tooltip-static";
		this.overlayViewClassName = "ol-tooltip";
		this.clickIdx = 0;

		this.isHelpTooltip = true;
		this.isMeasureTooltip = true;
		this.isStop = false;

		this.control = {
			measure: null,
		};

		this._overlayEvent = null;
		this.overlayLayer = null;

		this._init();

		window.sisMeasure = this;

		// 드론 면적측정 관련
		this.droneFeature = new Feature();
		this.droneProps = {
			area: 0,
			geom: "",
			center: [],
		};
	}

	_init = () => {
		this.measureLayer = new VectorLayer({
			name: "measureLayer",
			id: "measureLayer",
			source: new VectorSource(),
			projection: this.map.getView().getProjection().getCode(),
			style: new Style({
				fill: new Fill({
					color: "rgba(255, 255, 255, 0.5)",
				}),
				stroke: new Stroke({
					color: "red",
					width: 2,
				}),
				image: new CircleStyle({
					radius: 7,
					fill: new Fill({
						color: "#ffcc33",
					}),
				}),
			}),
		});

		this.map.addLayer(this.measureLayer);
	};

	// 측정 타입 설정
	setMeasureType = (type) => {
		const self = this;

		this.type = type;

		this.control.measure = new Draw({
			source: this.measureLayer.getSource(),
			type: type,
			dragVertexDelay: 100,
			wrapX: true,
			condition: function (evt) {
				if (evt.originalEvent.buttons === 2) {
					self.stopMeasure();

					self.map.set("contextMenu", false);
					setTimeout(() => {
						self.map.set("contextMenu", true);
					}, 1000);

					return false;
				} else return true;
			},
			style: new Style({
				fill: new Fill({
					color: "rgba(255, 255, 255, 0.2)",
				}),
				stroke: new Stroke({
					color: "rgba(255, 0, 0, 0.8)",
					lineDash: [10, 10],
					width: 2,
				}),
				image: new CircleStyle({
					radius: 5,
					stroke: new Stroke({
						color: "rgba(0, 0, 0, 0.7)",
					}),
					fill: new Fill({
						color: "rgba(255, 255, 255, 0.2)",
					}),
				}),
			}),
		});
	};

	// 측정 시작
	startMeasure = (type, isHelpTooltip, isMeasureTooltip, isStop) => {
		// console.log("Start measure " + type);

		const self = this;

		if (isHelpTooltip) this.isHelpTooltip = true;
		if (isMeasureTooltip) this.isMeasureTooltip = true;

		if (this._overlayEvent) this.map.un(this._overlayEvent);
		this.map.removeOverlay(this.overlayLayer);

		this._clear();
		this.isMeasure = true;
		this.setMeasureType(type);
		this.measureFeature = null;

		// 지도 contextMenu 방지
		this.map.set("contextMenu", false);

		this.measureFeatures = this.measureLayer.getSource().getFeatures();
		var control = this.control.measure;
		this.map.removeInteraction();
		this.map.addInteraction(control);

		if (this.isMeasureTooltip) this._createMeasureTooltip();

		if (this.isHelpTooltip) this._createHelpTooltip();

		control.on(
			"drawstart",
			function (evt, e) {
				if (isStop) self._clear();
				self.measureFeature = evt.feature;
			},
			this
		);

		control.on(
			"drawend",
			function (evt, e) {
				if (self.isMeasureTooltip) {
					self.clickIdx = -1;

					if (type === "LineString") {
						$(".ol-tooltip.creating").removeClass("creating");
						self.map.removeOverlay(self.overlayLayer);

						self.measureFeature = null;
						self.overlayLayer = null;
						self._createMeasureTooltip();
					} else {
						//const length = self.measureFeature.getGeometry().getCoordinates()[0].length;
						//const geoms = self.measureFeature.getGeometry().getCoordinates()[0];
						//const lineString = new LineString(geoms);
						// self.overlayElement.firstElementChild.innerHTML = self._calculateDistance(lineString);

						// self.overlayLayer.setPosition(self.measureFeature.getGeometry().getCoordinates()[0][length - 1]);

						self._createMeasureTooltip();

						$(".ol-tooltip.creating").removeClass("creating");
						//self.map.removeOverlay(self.overlayLayer);

						self.overlayElement.className = self.overlayClassName;
						self.overlayLayer.setOffset([0, -7]);

						const geom = self.measureFeature.getGeometry();
						const output = self._calculateArea(geom);
						const coord = geom.getInteriorPoint().getCoordinates();

						self.overlayElement.firstElementChild.innerHTML = output;
						self.overlayLayer.setPosition(coord);

						self.measureFeature = null;
						self.overlayLayer = null;
						self._createMeasureTooltip();
					}
				}

				if (isStop) self._clear();
			},
			self
		);
		//
		this.map.on("pointermove", self._pointerMove);
		//if (type === "LineString") self.map.on("click", self._singleClick);
		self.map.on("click", self._singleClick, self);
		this.map.getViewport().addEventListener("mouseout", this._hideTooltip);
	};

	// 드론 면적 측정 시작
	startDroneMeasure = (type, isHelpTooltip, isMeasureTooltip, isStop, isClear = false) => {
		// console.log("Start Drone measure " + type);
		if (isClear) this._allClear();

		const self = this;

		if (isHelpTooltip) this.isHelpTooltip = true;
		if (isMeasureTooltip) this.isMeasureTooltip = true;
		else this.isMeasureTooltip = isMeasureTooltip;

		if (this._overlayEvent) this.map.un(this._overlayEvent);
		this.map.removeOverlay(this.overlayLayer);

		this.isMeasure = true;
		this.setMeasureType(type);
		this.measureFeature = null;

		this.measureFeatures = this.measureLayer.getSource().getFeatures();
		var control = this.control.measure;
		this.map.removeInteraction();
		this.map.addInteraction(control);

		if (this.isMeasureTooltip) this._createMeasureTooltip();

		if (this.isHelpTooltip) this._createHelpTooltip();

		control.on(
			"drawstart",
			function (evt, e) {
				if (isStop) self._clear();
				self.measureFeature = evt.feature;
			},
			this
		);

		control.on(
			"drawend",
			function (evt, e) {
				if (self.isMeasureTooltip) {
					self.overlayElement.className = self.overlayClassName;
					self.overlayLayer.setOffset([0, -7]);

					self.measureFeature = null;
					self.overlayLayer = null;

					self._createMeasureTooltip();
				}

				var format = new WKT();
				const feature = evt.feature;
				const geom = feature.getGeometry();

				let droneGeom = self.droneFeature.getGeometry();
				const droneCoordinates = droneGeom ? droneGeom.getCoordinates() : [];
				if (!droneGeom) {
					// 처음 면적 측정시 지오메트리 생성
					self.droneFeature.setGeometry(new MultiPolygon([geom.getCoordinates()]));

					droneGeom = self.droneFeature.getGeometry();
				} else {
					// 멀티폴리곤에 지오메트리 추가
					droneCoordinates.push(geom.getCoordinates());
					droneGeom.setCoordinates(droneCoordinates);
				}

				const polygons = droneGeom.getPolygons();
				let area = 0;

				polygons.forEach((polygon) => {
					area += polygon.getArea();
				});
				const wkt = format.writeGeometry(droneGeom);
				const center = getCenter(droneGeom.getExtent());

				self.droneProps.area = area;
				self.droneProps.geom = wkt;
				self.droneProps.center = transform(center, "EPSG:5181", "EPSG:5186");

				if (isStop) self._clear();
			},
			self
		);
		//
		this.map.on("pointermove", self._pointerMove);
		this.map.getViewport().addEventListener("mouseout", this._hideTooltip);
	};

	stopDroneMeasure = () => {
		const data = {
			area: this.droneProps.area,
			geom: this.droneProps.geom,
			center: this.droneProps.center,
		};

		this.stopMeasure();

		return data;
	};

	// 우클릭시 모두 종료
	_rightClick = (evt) => {
		evt.preventDefault();
		this._clear();
		this.stopMeasure();
	};

	// 지도클릭 이벤트
	_singleClick = (evt) => {
		if (this.isMeasureTooltip) {
			this.clickIdx++;

			if (this.clickIdx > 1) {
				this.overlayElement.className += "creating";
				this.overlayLayer.setOffset([0, -7]);

				if (this.type === "LineString") {
					const length = this.measureFeature.getGeometry().getCoordinates().length;
					this.overlayLayer.setPosition(this.measureFeature.getGeometry().getCoordinates()[length - 2]);

					this.overlayLayer = null;
					this._createMeasureTooltip();
				} else {
					const length = this.measureFeature.getGeometry().getCoordinates()[0].length;
					// console.log(length);
					const geoms = this.measureFeature
						.getGeometry()
						.getCoordinates()[0]
						.slice(0, length - 2);
					//const lineString = new LineString(geoms);
					// this.overlayElement.firstElementChild.innerHTML = this._calculateDistance(lineString);

					// this.overlayLayer.setPosition(this.measureFeature.getGeometry().getCoordinates()[0][length - 2]);
				}
			}
		}
	};

	// 마우스 움직일 때 이벤트
	_pointerMove = (evt) => {
		if (evt.dragging || evt.originalEvent.target.tagName !== "CANVAS") {
			return;
		}

		$("div.ol-tooltip").not($(".tooltip-static")).show();

		/** @type {string} */
		var helpMsg = "화면 클릭시 그리기를 시작합니다<br/>우측 마우스 버튼 클릭시 그리기를 종료합니다";
		/** @type {ol.Coordinate|undefined} */
		var tooltipCoord = evt.coordinate;

		if (this.measureFeature) {
			var output;
			var geom = this.measureFeature.getGeometry();
			if (geom instanceof Polygon) {
				output = this._calculateArea(geom);
				helpMsg = this.continueMsg;
				tooltipCoord = geom.getInteriorPoint().getCoordinates();
			} else if (geom instanceof LineString) {
				output = this._calculateDistance(geom);
				helpMsg = this.continueMsg;
				tooltipCoord = geom.getLastCoordinate();
			}

			if (this.isMeasureTooltip) {
				//this.overlayElement.innerHTML = output;
				//if (this.overlayLayer) {
				this.overlayElement.firstElementChild.innerHTML = output;
				this.overlayLayer.setPosition(tooltipCoord);
				//}
			}
		}

		if (this.isHelpTooltip) {
			this.overlayViewElement.innerHTML = helpMsg;
			this.overlayViewLayer.setPosition(evt.coordinate);
		}
	};

	// 거리측정
	_calculateDistance = (line) => {
		var length = getLength(line);

		var output;
		if (length > 100) {
			output = Math.round((length / 1000) * 100) / 100 + " km";
		} else {
			output = Math.round(length * 100) / 100 + " m";
		}
		return output;
	};

	_calculateArea = (polygon) => {
		var area = getArea(polygon);

		var output;
		if (area > 10000) {
			output = Math.round((area / 1000000) * 100) / 100 + " km<sup>2</sup>";
		} else {
			output = Math.round(area * 100) / 100 + " m<sup>2</sup>";
		}
		return output;
	};

	_createMeasureTooltip = (className = "") => {
		this.overlayElement = document.createElement("div");
		var spanElement = document.createElement("span");
		var closeElement = document.createElement("span");
		closeElement.className = "close";
		closeElement.innerHTML = "X";

		this.overlayElement.appendChild(spanElement);
		this.overlayElement.appendChild(closeElement);

		closeElement.onclick = (evt) => {
			$(evt.target).closest(".ol-tooltip-static").remove();
		};

		this.overlayElement.className = this.overlayClassName + " " + className;

		this.overlayLayer = new Overlay({
			element: this.overlayElement,
			id: "measure",
			offset: [0, -20],
			stopEvent: false,
			positioning: "bottom-center",
		});
		this.map.addOverlay(this.overlayLayer);
	};

	_createHelpTooltip = (className = "") => {
		this.overlayViewElement = document.createElement("div");
		this.overlayViewElement.className = this.overlayViewClassName + " " + className;
		this.overlayViewLayer = new Overlay({
			element: this.overlayViewElement,
			id: "measure",
			offset: [25, 0],
			stopEvent: false,
			positioning: "center-left",
		});
		this.map.addOverlay(this.overlayViewLayer);
	};

	_hideTooltip = () => {
		this.map.getViewport().addEventListener("mouseout", function () {
			$("div.ol-tooltip").not($(".ol-tooltip-static")).hide();
		});
	};

	_removeTooltip = () => {
		$("div.ol-tooltip").not($(".ol-tooltip-static")).remove();
	};

	_allClear = () => {
		this.measureLayer.getSource().clear();
		// this.map.removeLayer(this.measureLayer);
		this.map.removeEventListener("pointermove", this._pointerMove);
		this.map.removeEventListener("click", this._singleClick);
		this.map.removeInteraction(this.control.measure);

		const overlayers = this.map.getOverlays().getArray();
		const removeItems = [];
		overlayers.forEach((item, idx) => {
			if (item.getId() === "measure") {
				removeItems.push(item);
			}
		});

		removeItems.forEach((item, idx) => {
			this.map.removeOverlay(item);
		});

		this.isMeasure = false;

		this.droneFeature = new Feature();
		this.droneProps = {
			area: 0,
			geom: "",
		};

		this.map.set("contextMenu", true);
	};

	_clear = () => {
		this.map.removeEventListener("pointermove", this._pointerMove);
		this.map.removeEventListener("click", this._singleClick);
		this.map.getViewport().removeEventListener("mouseout", this._hideTooltip);

		this._removeTooltip();

		this.clickIdx = 0;

		this.map.removeInteraction(this.control.measure);

		if (this.overlayLayer) {
			this.map.removeOverlay(this.overlayLayer);
			this.overlayLayer = null;
			$(".ol-tooltip.creating").remove();
		}

		$("div.measure-tooltip").not($(".tooltip-static")).css({
			display: "none",
		});
		this.isMeasure = false;

		this.droneFeature = new Feature();
		this.droneProps = {
			area: 0,
			geom: "",
		};

		this.map.set("contextMenu", true);
	};

	stopMeasure = () => {
		this._clear();
	};
}
